import { render, staticRenderFns } from "@/modules/Ticket/templates/ticket-create.html?vue&type=template&id=99740796&scoped=true&"
import script from "@/modules/Ticket/scripts/ticket-create.ts?vue&type=script&lang=js&"
export * from "@/modules/Ticket/scripts/ticket-create.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Ticket/styles/ticket-create.scss?vue&type=style&index=0&id=99740796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99740796",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
